// extracted by mini-css-extract-plugin
export default {"figure":"PortraitFrame_figure__tq2uv","frame":"PortraitFrame_frame__IqsD4","photo":"PortraitFrame_photo__E26Pv","caption":"PortraitFrame_caption__0LtG6"};